module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.popupShown) ? _c('div', {
    staticClass: "overlay transparent"
  }, [_c('div', {
    staticClass: "modal popup"
  }, [_c('span', {
    staticClass: "popup-close",
    on: {
      "click": function($event) {
        _vm.closePopup()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('header', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Mit Zissel auf der Gewinnerseite!")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('a', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.closePopupAndRedirect()
      }
    }
  }, [_c('span', [_vm._v("Hier geht’s zum"), _c('br'), _vm._v("\n                        Bayron-Man 2010-Gewinnspiel!")])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f5351eb2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/partials/popup-game.vue
// module id = 36
// module chunks = 0